// extracted by mini-css-extract-plugin
export default {"root":"_5+opE","price":"JiMje","aMonth":"U6Y3+"};